module.exports = __webpack_public_path__ + "img/full.4b3dcfdb.png";